import { actionTypes } from "../contants/actionTypes";

const initialState = {
    data: {},
    loading: false,
    error: null,
    saving: false,
    saveSuccess: false
};

export const configurationCountReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.LoadingConfiguration:
            return {
                ...state,
                loading: true,
                error: null,
                saveSuccess: false
            };
        case actionTypes.SavingConfiguration:
            return {
                ...state,
                saving: true,
                error: null,
                saveSuccess: false
            };
        case actionTypes.LoadAllConfiguration:
            return {
                ...state,
                data: action.payload,
                loading: false,
            };
        case actionTypes.LoadingConfigurationError:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        case actionTypes.SaveConfigurationError:
            return {
                ...state,
                saving: false,
                error: action.payload,
            };
        case actionTypes.SaveConfigurationSuccess:
            return {
                ...state,
                saving: false,
                saveSuccess: true,
                data: { ...state.data, ...action.payload }
            };
        default:
            return state;
    }
};
